export const titleStyle = { height: "100%", borderRadius: "15px" };
export const formStyle = { paddingLeft: '2vw', paddingTop: '5%', paddingRight: '3vw', fontFamily: "Poppins-Regular" };
export const formInputStyle ={ borderRadius: "10px", color: 'black' };
